var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"text":_vm.workShopLocales[_vm.locale],"variant":"primary","right":_vm.right}},_vm._l((_vm.locales),function(value,key){return _c('b-dropdown-item',{key:key,on:{"click":function($event){$event.preventDefault();return _vm.setLocale(key)}}},[_vm._v("\n    "+_vm._s(value)+"\n  ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }